import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
	theme: {
		themes: {
			light: {
			primary: '#0065c0',
			accent: '#72C564',
			secondary: '#0054A6',
			success: '#19BC88',
			warning: '#FFC107',
			error: '#DC1A1A',
			blue: '#295396',
			gray: '#333',
			purple: '#978ded',
			pink: '#ff78b4',
			grey: '#666',
			lightgrey: '#999',
			},
		}
	},
	icons: {
		iconfont: 'mdi'
	}
})
